/**
 * fastLiveFilter jQuery plugin 1.0.3
 * 
 * Copyright (c) 2011, Anthony Bush
 * License: <http://www.opensource.org/licenses/bsd-license.php>
 * Project Website: http://anthonybush.com/projects/jquery_fast_live_filter/
 **/

jQuery.fn.fastLiveFilter = function (list, options) {
    // Options: input, list, timeout, callback
    options = options || {};
    list = jQuery(list);
    var input = this;
    var lastFilter = '';
    var timeout = options.timeout || 0;
    var callback = options.callback || function () { };

    var keyTimeout;

    // NOTE: because we cache lis & len here, users would need to re-init the plugin
    // if they modify the list in the DOM later.  This doesn't give us that much speed
    // boost, so perhaps it's not worth putting it here.
    var lis = list.children();
    var len = lis.length;
    var oldDisplay = len > 0 ? lis[0].style.display : "block";
    callback(len); // do a one-time callback on initialization to make sure everything's in sync

    input.change(function () {
        if (input.val().length === 0) {
            showFolders(true);
        }
        else {
            showFolders(false);
        }


        var filter = input.val().toLowerCase();
        var li, innerText;
        var numShown = 0;
        for (var i = 0; i < len; i++) {
            li = lis[i];
            innerText = !options.selector ?  li.textContent || li.innerText || "" : $(li).find(options.selector).text();


            if (innerText.toLowerCase().indexOf(filter) >= 0) {

                if (li.style.display === "none") {
                    li.style.display = oldDisplay;

                    // li.closest($(".folder-header")).css("display", "block");
                }
                numShown++;
                //console.log("Li: %o", li);

            } else {
                if (li.style.display !== "none") {
                    li.style.display = "none";

                }
            }
        }
        callback(numShown);
        // var endTime = new Date().getTime();
        // console.log('Search for ' + filter + ' took: ' + (endTime - startTime) + ' (' + numShown + ' results)');
        return false;
    }).keydown(function () {
        clearTimeout(keyTimeout);
        keyTimeout = setTimeout(function () {
            if (input.val() === lastFilter) return;
            lastFilter = input.val();
            input.change();
        }, timeout);
    });
    return this; // maintain jQuery chainability
};

$(function () {
    //$('#search_input').fastLiveFilter('.file-list');
   // $('#search_input').fastLiveFilter('.folder-container');
 
    // $('.accordionTitle.hasChildren a.accTrigger').click(function (event) {
    //     event.preventDefault();
    //     var $nextUL = $(this).next();
    //     var $thisUL = $(this).closest('ul');

    //     if ($nextUL.css('display') == 'block') {
    //         $nextUL.css('display', 'none');
    //         $thisUL.removeClass('active')
    //     } else {
    //         $nextUL.css('display', 'block');
    //         $thisUL.addClass('active')
    //     }
    //     //$(this).toggleClass("guideline-list-open");
    // });


    $('#search_input').fastLiveFilter('.file-list', {
        callback: function (total) {
            //console.log('Callback : ' + $('#toolDocumentFilter').length);
            if ($('#search_input').length && $('#search_input').val().length > 0) {
           
                var containers = $(".file-list__container"); 
          
                $("folder-container").addClass('accordion--open');
                $("folder-container").removeClass('accordion--closed');

                var tools = $('.file-list__container');
                //console.log("Containers: %o", tools);
               // tools.css('display', 'block');
                $(".folder-container").removeClass("accordion--closed");
                $(".folder-container").addClass("accordion--open");
                tools.each(function (index) {
                    var thisToolGroup = $(tools[index]);
                   // console.log('test : %o - %o', thisToolGroup, thisToolGroup.children('li').filter(function () { return $(this).css("display") == "block" }).length);
                    if (thisToolGroup.children('li').filter(function () { return $(this).css("display") === "block"; }).length === 0) {
                        //console.log('Parent hide : ' + thisToolGroup.parent());
                        //thisToolGroup.parent('.file-list').css('display', 'none');
                        //thisToolGroup.parent().addClass("closed");
                        //thisToolGroup.parent().removeClass("open");
                    } else {
                        //console.log('Parent show  : ' + thisToolGroup.parent());
                        thisToolGroup.parent().css('display', 'block');
                    }
                });
            }
            else {     
                //console.log("********");
                //$('.file-list__container').css('display', 'none');
                $(".folder-container").removeClass('accordion--open');
                //$(".folder-container").addClass('accordion--closed');
                
            }
            cleanUp();
        }
    

    });

    $('.document-library__clear').click(function(){
        $('.document-library__input').val("").trigger('keydown');
    });

});
function cleanUp() {
    var headers = $(".folder-container");
    $.each(headers, function (i, v) {
        //console.log("Next v: %o", $(v).next());
      
        if ($(v).find(".file-list__item:not([style='display: none;'])").length === 0) {
            $(v).css("display", "none");
        }
    });
}
function showFolders(empty) {
   
   // console.log("Show folders");
    var headers = $(".folder-container");
    $.each(headers, function (i, v) {
        if (empty === true) {
           
            $(".folder-container").css("display", "block");
        }
        else {
            //console.log($(v).next().find(".file-list__item:not([style='display: none;'])").length);
            if ($(v).next().find(".file-list__item:not([style='display: none;'])").length > 0) {
                $(v).css("display", "block");
            }
        }
    });
}